<picture
    ><source *ngIf="webpSanitized" type="image/webp" [srcset]="webpSanitized" />
    <source *ngIf="jpegSanitized" type="image/jpeg" [srcset]="jpegSanitized" />
    <source *ngIf="pngSanitized" type="image/png" [srcset]="pngSanitized" />
    <img [ngClass]="imgClasses" [width]="width" [height]="height" [priority]="priority || null" [ngSrc]="webp || jpeg || png" [alt]="alt"
/></picture>
